import { useContext, useState } from 'react'

import {
  Avatar,
  Box,
  Icon,
  Image,
  Switch,
  Tabs,
  Text,
} from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { ConfirmModalContext } from '../../../../components/ConfirmModal'
import { GlobalDataContext } from '../../../../contexts/globalData'
import { sdk } from '../../../../services/sdk'
import { docMask } from '../../../../utilities/masks/brasilianDocuments'
import { ProviderContext } from '../../provider.context'

import * as Styles from './provider-info.styles'
export const ProviderInfo = () => {
  const theme = useTheme()
  const { data } = useContext(ProviderContext)
  const { confirmModal } = useContext(ConfirmModalContext)
  const [isChecked, setIsChecked] = useState(data?.status === 'active')

  const { companySegmentType } = useContext(GlobalDataContext)
  const changeStatus = async () => {
    if (
      await confirmModal(
        'Mudar status',
        'Tem certeza que deseja mudar o status para esse fornecedor?',
      )
    ) {
      try {
        await sdk.company.changeStatus(
          data?.id ?? '',
          !isChecked ? 'active' : 'inactive',
        )
        setIsChecked(!isChecked)
      } catch (error) {}
    }
  }
  const segment =
    data && companySegmentType
      ? companySegmentType[data?.segment as keyof typeof companySegmentType]
      : null
  const [tab, setTab] = useState('Dados')
  const initials = data?.name
    ? data?.name
        .split(' ')
        .slice(0, 2)
        .map((n) => n[0])
        .join('')
    : ''
  return data ? (
    <Styles.ProviderInfoContainer
      borderRadius={theme.border_radius.table}
      boxShadow={theme.box_shadow.card}
      backgroundColor={theme.colors.custom.white}
      padding={3}
      gap={4}
      direction="column"
      flex={1}
    >
      <Box gap={2}>
        <Box width="68px" height="68px">
          <Avatar
            size={68}
            backgroundColor="secondary"
            color="primary"
            fontSize="small"
          >
            {data.profile?.assets?.logo ? (
              <Image
                src={data.profile.assets.logo}
                alt="Sidebar"
                objectFit="cover"
                borderRadius="50%"
              />
            ) : (
              <Text fontWeight={'bold'} color="primary">
                {initials}
              </Text>
            )}
          </Avatar>
        </Box>
        <Box direction="column" justifyContent="space-between" gap={1}>
          <Text size="large">{data.name}</Text>
          <Box
            borderRadius={theme.border_radius.input}
            boxShadow={theme.box_shadow.card}
            padding={1}
            alignItems="center"
            gap={1}
          >
            {segment && (
              <>
                <Styles.SegmentColor bgColor={segment.color} />
                {segment.translate}
              </>
            )}
          </Box>
        </Box>
      </Box>
      <Box direction="column" gap={2} width="100%">
        <Tabs
          tabs={['Dados', 'Localização', 'Contato']}
          active={tab}
          onChangeTab={(_tab) => setTab(_tab)}
        />
        <Box minHeight="115px">
          {tab === 'Dados' && (
            <Box direction="column" gap={2}>
              <Box direction="column">
                <Text size="small" fontWeight={500}>
                  Razão Social
                </Text>
                <Text size="small">{data.name}</Text>
              </Box>
              <Box direction="column">
                <Text size="small" fontWeight={500}>
                  CNPJ
                </Text>
                <Text size="small">{docMask(data.taxId)}</Text>
              </Box>
            </Box>
          )}
          {tab === 'Localização' && (
            <Box direction="column" gap={2}>
              <Text size="small" fontWeight={500}>
                Localização
              </Text>
              <Box alignItems="center" gap={1}>
                <Icon name="map_pin" />
                <Text size="small">{data.address?.geoCoords?.address}</Text>
              </Box>
            </Box>
          )}
          {tab === 'Contato' && (
            <Box direction="column" gap={2}>
              <Text size="small" fontWeight={500}>
                Contato
              </Text>
              <Box direction="column">
                <Box alignItems="center" gap={1}>
                  <Icon name="mail" />
                  <a href={`mailto:${data.email}`}>
                    <Text size="small">{data.email}</Text>
                  </a>
                </Box>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
      <Box>
        <Switch
          checked={isChecked}
          preventEvent
          onChange={() => {
            changeStatus()
          }}
          labelRight={`Fornecedor ${isChecked ? 'ativo' : 'inativo'}`}
        />
      </Box>
    </Styles.ProviderInfoContainer>
  ) : null
}
